module.exports = "https://cdn.hellotech.com/client-assets/optimumLogo_4f5ebc9a1a2e4c002b90f44a62d61ffa.svg";